// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IStdDevEx } from './iStdDevEx';
export const iStdDev = 'iStdDev';
export class IStdDev extends IStdDevEx {
    constructor(period, maMethod, shift, priceType) {
        super(period, maMethod, shift, priceType);
    }
    get Name() {
        return iStdDev;
    }
}
